module.exports = __webpack_public_path__ + "googlepay.c552fc50a7f2191c69a125b14f60bf7a.png";